import { Injectable } from '@angular/core'
import {
  EventType,
  GlobalMessagingService,
  HeliosMessageType,
  JobFailedEvent,
  JobPayload,
} from '@helios/messaging'
import {
  JobsPayload,
  RootState,
  selectLegacyUserId,
  showJobsAction,
} from '@helios/state-management'
import { Store } from '@ngrx/store'
import { ToastrService } from 'ngx-toastr'
import { filter } from 'rxjs/operators'

@Injectable({
  providedIn: 'root',
})
export class JobFailureService {
  /** @internal */
  _userId?: number

  constructor(
    private readonly store: Store<RootState>,
    private readonly toastrService: ToastrService,
    private readonly messagingService: GlobalMessagingService,
  ) {
    this.initStore()
  }

  /** @internal */
  initStore() {
    this.store
      .select(selectLegacyUserId)
      .subscribe((userId?: number) => (this._userId = userId))
  }

  init() {
    this.messagingService
      .on<unknown, JobFailedEvent>(
        EventType.MESSAGE,
        HeliosMessageType.JobFailed,
      )
      // listen jobFailed events to user specific only
      .pipe(filter(failedEvent => failedEvent.payload.userId === this._userId))
      // Display the toast notification along with jobId
      .subscribe(failedEvent =>
        this.notifyUserWhenJobFailed(failedEvent.payload),
      )
  }

  notifyUserWhenJobFailed(payload: JobPayload) {
    this.toastrService
      .error(
        `A job that you submitted has failed. Click to see more details. Job ID ${payload.jobId}`,
        `Job Failure - Account ID ${payload.accountId}`,
        {
          timeOut: 30000, // 30 sec
          extendedTimeOut: 10000, // 10 sec
        },
      )
      // Load jobs panels ( if not opened ) and highlight job
      .onTap.subscribe(() =>
        this.store.dispatch(
          showJobsAction(this.failurePayloadToJobPayload(payload)),
        ),
      )
  }
  failurePayloadToJobPayload(payload: JobPayload): JobsPayload {
    return {
      userId: payload.userId,
      jobIds: [payload.jobId],
      accountIds: [payload.accountId],
      reconDate: payload.reconDate,
    }
  }
}
